import React from 'react';
import MediaItem from "app/app/mediaSelector/atoms/MediaItem";
import useMediaContext from "app/app/mediaSelector/hooks/use-media-context";
import MediaItemPreviewOnly from "app/app/mediaSelector/atoms/MediaItemPreviewOnly";
import useMediaFilter from "app/app/mediaSelector/hooks/use-media-filter";


function MediaGrid() {
    const {filteredItems} = useMediaFilter();
    console.log(filteredItems)

    return (
        <div className={'media-grid page_container'}>
            {filteredItems.map((mediaItem) => {
                if(mediaItem.isNotDownloadable) {
                    return <MediaItemPreviewOnly key={mediaItem.id} media={mediaItem} />
                }
                return <MediaItem key={mediaItem.id} media={mediaItem} />
            })}
        </div>
    );
}

export default MediaGrid;
